import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useMarketplaceInfo = () => {
  const marketplaceInfo = useSelector(
    (state: RootState) => state.auth.marketplaceInfo
  );
  const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);

  return {
    branchMarketplaceId: marketplaceInfo?.branchMarketplaceId,
    marketplaceId: marketplaceInfo?.marketplaceId,
    isReady:
      isAdmin ||
      (marketplaceInfo?.branchMarketplaceId && marketplaceInfo?.marketplaceId),
    isAdmin,
    marketplaceInfo,
  };
};
